import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    // No minimum height: the card lives in a fixed one-screen grid, so the chart
    // has to shrink with the card instead of forcing an inner scrollbar.
    chartWrapper: {
        height: "100%",
        width: "100%",
    },
    loadingWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
    },
}));
